import {
  LOAD_BRIEFCASES,
  LOADING_BRIEFCASES,
  ERROR_BRIEFCASES,
} from "./briefcaseTypes";
import axios from "axios";
import { buildApiUrl, headersRequest } from "../../helpers";

export const fetchBriefcases = () => {
  return (dispatch) => {
    dispatch({ type: LOADING_BRIEFCASES });
    const requestUrl = buildApiUrl("briefcases");
    axios
      .get(requestUrl, headersRequest(requestUrl))
      .then((res) => {
        dispatch({
          type: LOAD_BRIEFCASES,
          payload: res.data,
        });
      })
      .catch(() => {
        dispatch({
          type: ERROR_BRIEFCASES,
        });
      });
  };
};
